import styled from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import BaseRadio from '@r1-frontend/ui-react/components/controls/baseRadio';
import { DescribedCost } from '@r1-frontend/ui-react/components/costs';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { IndentContainer, ListContainer, withRadius } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import { TInstallmentOptionProps } from './types';

const Installment = ({
    options,
    onSelect,

    ...props
}: TInstallmentOptionProps): JSX.Element => {
    return (
        <IndentContainer $united={[16]} {...props}>
            <ListContainer $size={20} $direction={'row'}>
                {Object.entries(options).map(([id, option]) => (
                    <BaseRadio
                        key={id}
                        size='S'
                        name={'PurchaseOption'}
                        data-test='option'
                        onChange={onSelect(option.cost, option.period)}
                        disabled={option.disabled}
                    >
                        <DescribedCost
                            isReverse={true}
                            installmentPeriod={option.period}
                        >
                            {option.cost}
                        </DescribedCost>
                    </BaseRadio>
                ))}
            </ListContainer>
        </IndentContainer>
    );
};

export default styled(withRadius(Installment, { $radius: 16 }))`
    background-color: ${COLORS.BgMain};
    cursor: pointer;

    label {
        width: 100%;
    }

    input[type='radio'] {
        cursor: pointer;
        align-self: center;
    }

    & ${ListContainer} + ${ListContainer} ${DescribedCost} {
        cursor: pointer;
        width: 100%;
        flex-direction: row-reverse;
        align-items: center;
        justify-content: space-between;
        flex-wrap: nowrap;
    }

    @media (min-width: ${wideBreakpoints.mobile}) {
        & ${ListContainer}:first-child ${DescribedCost} {
            cursor: pointer;
            width: 100%;
            flex-direction: row-reverse;
            align-items: center;
            justify-content: space-between;
        }
    }

    & ${ListContainer} + ${ListContainer} {
        margin-top: 16px;
        padding-top: 12px;
        border-top: 1px solid ${COLORS.BgSecondary};
    }

    & ${Button}.selected * {
        color: ${COLORS.TextWhite} !important;
    }
`;
